import { MutableRefObject, ReactNode } from "react";
import styled from "styled-components";

import { useLayoutSize } from "../providers/LayoutProvider";
import { LayoutSize } from "../util/device";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

const Button = styled(PlayerControlButtonComponent)`
  span {
    white-space: nowrap;
  }
  // space between icon and label when both are showing
  svg + span {
    margin-left: 10px;
  }
`;

export type TPlayerControlLabelButton = {
  label?: string;
  autoHideLabel?: boolean;
  Icon?: ReactNode;
  hoverText: string;
  disabled: boolean;
  buttonRef?: MutableRefObject<null | HTMLButtonElement>;
} & React.HTMLAttributes<HTMLButtonElement>;

export const PlayerControlLabelButton = ({
  label,
  autoHideLabel,
  ...props
}: TPlayerControlLabelButton) => {
  const layoutSize = useLayoutSize();

  // default auto hide to true
  if (
    autoHideLabel !== false &&
    [LayoutSize.SMALL, LayoutSize.SMALLEST].includes(layoutSize)
  ) {
    label = "";
  }

  return <Button label={label} interactive {...props} />;
};
